module.exports = __webpack_public_path__ + "media/images/top-list@2x-bd8ce650fa75b45ea3c22c6983cdb6cd.png";